import { useQuery } from '@tanstack/react-query';
import { useKeycloak } from '@react-keycloak/web';

interface ObjectJson {
  message: string;
  data: string;
}

export function useObjectJson(uuid: string, container: string, options?: any) {
  const { keycloak } = useKeycloak();

  return useQuery(['object-json', uuid, container], {
    enabled: !!uuid && !!container,
    queryFn: async (): Promise<ObjectJson> => {
      const body = {
        uuid: uuid,
        container: container,
      };

      const response = await fetch(
        `${
          import.meta.env.VITE_IMPORT_ENGINE_ENDPOINT
        }/api/v1/bundles/query_bundle/functions/get_object_json`,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${keycloak.token}`,
          },
          method: 'POST',
          body: JSON.stringify(body),
        }
      );

      return response.json();
    },
    ...options,
  });
}
